const netlifyIdentity = require("netlify-identity-widget")

netlifyIdentity.init()
